import React, { useLayoutEffect, useState } from 'react'
import api from './api'
import { encrypt } from './crypto'


import { Input, message, Space, Typography, Result, Button, Checkbox } from 'antd'



const { Text, Title, Link } = Typography

function encodeBase64(text) {
    // 将字符串转换为UTF-8编码的字节序列
    const utf8Bytes = new TextEncoder().encode(text);
    // 使用浏览器内置的btoa函数，但先转换为二进制字符串
    let binaryString = '';
    utf8Bytes.forEach(byte => {
        binaryString += String.fromCharCode(byte);
    });
    return btoa(binaryString);
}


let captcha_g = null


//  实名认证
function RealName(props) {
    // const [bindPhone, setBindPhone] = useState(false)
    const [bindPhoneData, setBindPhoneData] = useState({ phone_number: '', vcode: '' })
    const [bindPhoneCodeData, setBindPhoneCodeData] = useState(false)
    const [data, setData] = useState({ botToken: null, useragreement: false })

    useLayoutEffect(() => {
        setTimeout(() => {
            window.initGeetest4({
                captchaId: 'e2f7db7a36cae0fcec9320216a172878',
                nativeButton: {
                    width: '200px',
                },
            }, function (captcha) {
                // captcha为验证码实例
                captcha.appendTo("#DX_demo_RealName");// 调用appendTo将验证码插入到页的某一个元素中，这个元素用户可以自定义

                captcha_g = captcha

                captcha.onReady(function () {
                    //your code
                }).onSuccess(function () {
                    var token = captcha.getValidate()
                    setBindPhoneCodeData(token)

                    //your code
                }).onError(function () {
                    //your code
                })
            });
        }, 500);
    }, [])

    function onChange(e) {
        setBindPhoneData({
            ...bindPhoneData,
            [e.target.name]: e.target.value
        })
    }

    //  获取验证码
    // function get_verification_code() {
    //     let phone = bindPhoneData.phone_number


    //     if (!phone || typeof phone !== 'string' || !/^1[3-9]\d{9}$/.test(phone)) {
    //         return message.error('手机号格式不正确, 请重新填写!')
    //     }

    //     if (!bindPhoneCodeData) {
    //         message.warning('请完成人机验证')
    //         return
    //     }

    //     api.post('/api/v2/user/send_sms', {
    //         type: 'get_sms_code',
    //         value: {
    //             phone_number: encodeBase64(encodeBase64(phone)),
    //         },
    //         botToken: bindPhoneCodeData,
    //     })
    //         .then((res) => {
    //             if (res.data.code === 200) {
    //                 message.success('已经下发验证码, 请查收短信验证码!')
    //             } else {
    //                 message.error(res.data.data.text)
    //             }
    //         })
    //         .catch((error) => {
    //             message.error('网络异常,无法连接服务器')
    //         })

    //     // message.success('已经下发验证码, 请查收短信验证码!')
    // }

    //  确定绑定
    function v_verification_code() {
        if (!bindPhoneCodeData) {
            return message.error('请完成人机验证!')
        }

        if (!data.useragreement) {
            return message.error('请阅读并同意隐私保护协议!')
        }

        let id_number = bindPhoneData.id_number
        let real_name = bindPhoneData.real_name


        if (!real_name) {
            return message.error('请填写姓名!')
        }

        // 18位身份证校验
        const idCardReg =
            /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[0-9Xx]$/

        if (!id_number || typeof id_number !== 'string' || !idCardReg.test(id_number)) {
            return message.error('身份证号码格式不正确, 请重新填写!')
        }

        // 获取出生日期
        const birthday =
            id_number.substring(6, 10) + '-' +
            id_number.substring(10, 12) + '-' +
            id_number.substring(12, 14)

        const birthDate = new Date(birthday)
        const now = new Date()

        let age = now.getFullYear() - birthDate.getFullYear()

        const monthDiff = now.getMonth() - birthDate.getMonth()

        if (
            monthDiff < 0 ||
            (monthDiff === 0 && now.getDate() < birthDate.getDate())
        ) {
            age--
        }

        // 是否成年
        const isAdult = age >= 18

        console.log({
            age,
            isAdult
        })

        if (!isAdult) {
            return message.error('未成年人账号禁止进行相关操作!')
        }

        // message.success('验证已通过')




        // return {
        //     success: true,
        //     age,
        //     isAdult
        // }

        // console.log(encrypt(bindPhoneData.real_name));
        // console.log(encrypt(bindPhoneData.id_number));

        const key = Date
        message.loading({ key, content: '已加密传输, 系统正在校验...', })

        api.post('/api/v2/user/fealname', {
            type: 'add',
            real_name: encrypt(bindPhoneData.real_name),
            id_number: encrypt(bindPhoneData.id_number),
            botToken: bindPhoneCodeData,
        })
            .then((res) => {
                if (res.data.code === 200) {
                    message.success({ key, content: '成功实名, 请刷新页面!' })
                } else {
                    // message.error(res.data.data.text)
                    message.error({ key, content: res.data.data.text })

                    if (captcha_g) {
                        setBindPhoneCodeData(false)
                        captcha_g.reset(); // 调用该接口进行重置
                    }
                }
            })
            .catch((error) => {
                // message.error('网络异常,无法连接服务器')
                message.error({ key, content: '网络异常,无法连接服务器' })
            })
    }


    if (props.state.user.realname && props.state.user.realname.verified) {
        return (
            <Result title="此账户已完成实名认证" />
        )
    }

    if (!props.state.token) {
        // navigate('/login')
        return (
            <Result
                status="403"
                title="403"
                subTitle="请登录再访问页面"
            />
        )
    }

    return (
        <div style={{ width: 800, margin: 'auto', marginTop: 40 }}>
            <Title style={{ textAlign: 'center' }} level={3}>实名认证</Title>
            {/* <p style={{ color: '#fff' }}>根据本站的 <Link href="/useragreement" target='_blank'>《隐私保护协议》</Link> , 本次实名认证为验证您的身份是否具备法定消费能力用途, 您可以选择不实名。</p> */}
            <p style={{ color: '#fff' }}>
                根据 <Link href="/privacyprotectionagreement" target='_blank'>《隐私保护协议》</Link> ，
                为保障社区环境安全、防止未成年人参与限制性行为以及提升账号安全性，
                当前账户需完成实名认证。
            </p>

            <p style={{ color: '#fff' }}>
                本社区提供实名认证服务，
                部分第三方业务服务器可能接入本社区实名认证状态接口。
            </p>

            <p style={{ color: '#fff' }}>
                认证完成后，
                第三方业务服务器仅可获取认证状态结果，
                不会获取您的完整身份信息。
            </p>

            {/* <p style={{ color: '#fff' }}>
                您有权限对部分第三方业务服务器进行 授权/撤回 查询您的实名信息, 这可能会造成部分第三方业务服务器的服务无法正常使用。
            </p> */}

            <p style={{ color: '#fff' }}>
                您的实名信息将通过加密方式进行处理与存储，
                我们不会向第三方公开、出售或泄露您的个人信息。
            </p>

            <p style={{ color: '#fff' }}>
                未成年人账户可能被限制部分功能或消费行为。
            </p>

            <p style={{ color: '#fff' }}>
                继续认证即视为您已阅读并同意
                <Link href="/privacyprotectionagreement" target='_blank'>《隐私保护协议》</Link> 。
            </p>


            <div style={{ marginTop: 20 }}>
                <div style={{ width: '300px', marginTop: 20 }}>
                    <Text>姓名</Text>
                    <br />
                    <Input name='real_name' onChange={onChange} value={bindPhoneData.real_name} placeholder='请输入真实姓名' />
                </div>

                <div style={{ width: '300px', marginTop: 20 }}>
                    <Text>身份证号码</Text>
                    <br />
                    <Input name='id_number' onChange={onChange} value={bindPhoneData.id_number} placeholder='请输入身份证号码' />
                </div>

                <div id="DX_demo_RealName" style={{ marginBottom: 20, marginTop: 20 }}></div>

                <div style={{ marginTop: 20, width: '100px' }}>
                    {/* <Text>验证码</Text>
                    <br />
                    <Input style={{ width: '90%' }} name='vcode' onChange={onChange} value={bindPhoneData.vcode} /> */}
                </div>

                <div style={{ marginTop: 20 }}>
                    <Checkbox style={{ marginBottom: 20 }} checked={data.useragreement} onChange={(e) => {
                        setData({
                            ...data,
                            useragreement: e.target.checked
                        })
                    }}>我已阅读并同意 <a href="/useragreement" target='_blank'>《隐私保护协议》</a></Checkbox>

                    <Button type="primary" block onClick={v_verification_code}>安全认证</Button>
                </div>
            </div>
        </div>
    );
}

export default RealName